// TODO: after migration consider https://www.npmjs.com/package/analytics

import { info } from './logger';

type TapfiliateConversionOptions = {
  customer_id: string;
  always_callback?: boolean;
};

type TapfiliateCustomerOptions = {
  always_callback?: boolean;
};

type TapfiliateAffiliate = { id: string; firstname: string; lastname: string };
type TapfiliateClick = { created_at: string; referrer: unknown; landing_page: string };

type TapfiliateCommission = {
  affiliate: TapfiliateAffiliate;
  amount: number;
  approved: null;
  comment: null;
  commission_type: string;
  conversion_sub_amount: number;
  created_at: string;
  currency: string;
  id: number;
  kind: string;
  payout: unknown;
};

type TapfiliateResponse = {
  affiliate: TapfiliateAffiliate;
  affiliate_meta_data: unknown;
  click: TapfiliateClick;
  created_at: string;
  meta_data: unknown;
  program: { id: string; title: string; currency: string };
  warnings: unknown;
};

type TapfiliateCustomerResponse = TapfiliateResponse & {
  customer_id: string;
  id: string;
  status: string;
};

type TapfiliateConversionResponse = TapfiliateResponse & {
  amount: number;
  commissions: TapfiliateCommission[];
  customer: unknown;
  external_id: string;
  id: number;
  warnings: null;
};

type TapfiliateCustomerFunction = (
  tapFunction: 'customer',
  customerId: string,
  options: TapfiliateCustomerOptions,
  callback: Function
) => void;

type TapfiliateConversionFunction = (
  tapFunction: 'conversion',
  externalId: string,
  conversionAmount: number,
  options: TapfiliateConversionOptions,
  commissionType: string,
  callback: Function
) => void;

interface IWindowWithAffiliateTracking extends Window {
  tap: TapfiliateCustomerFunction | TapfiliateConversionFunction;
}

declare const window: IWindowWithAffiliateTracking;

export async function trackSignup(customerId: string) {
  if (!window.tap) {
    return;
  }
  return new Promise<void>(resolve => {
    const callback = (param1: unknown, response: TapfiliateCustomerResponse) => {
      info('Tapfiliate affiliate signup callback', param1, JSON.stringify(response));
      resolve();
    };

    (window.tap as TapfiliateCustomerFunction)?.(
      'customer',
      customerId,
      {
        always_callback: true,
      },
      callback
    );
  });
}

export async function trackConversion(
  externalId: string,
  customerId: string,
  commissionType: 'ordertip' | 'pagecreation',
  conversionAmount?: number
) {
  if (!window.tap) {
    return;
  }
  return new Promise<void>(resolve => {
    const callback = (param1: unknown, response: TapfiliateConversionResponse) => {
      info('Tapfiliate affiliate conversion callback', param1, JSON.stringify(response));
      resolve();
    };
    const options: TapfiliateConversionOptions = {
      customer_id: customerId,
      always_callback: true,
    };
    (window.tap as TapfiliateConversionFunction)?.(
      'conversion',
      externalId,
      conversionAmount,
      options,
      commissionType,
      callback
    );
  });
}
